import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 font-montserrat" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Buat Embargo Baru ", -1)
const _hoisted_5 = { class: "flex flex-row h-full" }
const _hoisted_6 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto pb-24" }
const _hoisted_7 = { class: "pt-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "py-2 text-20px text-gray-lp-300 font-semibold" }, " Detail Embargo ", -1)
const _hoisted_9 = { class: "py-3 w-3/4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Embargo", -1)
const _hoisted_11 = { class: "inline-block relative w-full my-2 mr-4" }
const _hoisted_12 = { class: "py-3 w-3/4 max-w-full" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, "Kota Asal", -1)
const _hoisted_14 = { class: "py-3 w-3/4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, "Destinasi", -1)
const _hoisted_16 = { class: "py-3 w-3/4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Tipe Pengiriman ", -1)
const _hoisted_18 = { class: "mt-4 pt-4 border-t border-gray-lp-400" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "py-2 text-20px text-gray-lp-300 font-semibold" }, " Detail Produk ", -1)
const _hoisted_20 = { class: "py-3 w-3/4" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Produk Pengiriman ", -1)
const _hoisted_22 = { class: "py-3 w-3/4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Komoditas Pengiriman ", -1)
const _hoisted_24 = { class: "py-3 w-3/4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Berat Maksimal ", -1)
const _hoisted_26 = { class: "w-1/3 my-4" }
const _hoisted_27 = { class: "mt-4 pt-4 border-t border-gray-lp-400" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "py-2 text-20px text-gray-lp-300 font-semibold" }, " Periode Embargo ", -1)
const _hoisted_29 = { class: "w-3/5 py-3" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Dimulai Dari ")
  ])
], -1)
const _hoisted_31 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_32 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_33 = { class: "w-3/5 py-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Sampai ")
  ])
], -1)
const _hoisted_35 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_InputAdornment = _resolveComponent("InputAdornment")!
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", null, [
              _createVNode(_component_button_fill, {
                title: "Simpan",
                onClick: _cache[2] || (_cache[2] = () => _ctx.onOpenSave()),
                class: "px-8",
                isDisabled: _ctx.isDisabled
              }, null, 8, ["isDisabled"])
            ])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.name = $event)),
                      class: "block appearance-none text-12px xxl:text-14px w-full text-black-lp-300 bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded shadow leading-tight focus:outline-none",
                      maxlength: 56,
                      placeholder: "Masukkan nama embargo"
                    }, null, 512), [
                      [_vModelText, _ctx.form.name]
                    ]),
                    _createVNode("div", {
                      class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-2 text-gray-lp-500 mr-2 text-12px",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                    }, _toDisplayString(_ctx.form.name.length) + "/56 ", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.originCityListData,
                    modelValue: _ctx.originCityExclude,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.originCityExclude = $event)),
                    modalTitle: "Kota Asal",
                    keyName: "name",
                    keyValue: "code",
                    isLoading: _ctx.isLoadingOriginCity,
                    placeholder: "Ketik atau pilih kota asal",
                    onFilter: _ctx.fetchOriginCity
                  }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
                ]),
                _createVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.destinationCityListData,
                    modelValue: _ctx.destinationCityExclude,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.destinationCityExclude = $event)),
                    modalTitle: "Destinasi",
                    keyName: "name",
                    keyValue: "code",
                    isLoading: _ctx.isLoadingDestinationCity,
                    placeholder: "Ketik atau pilih destinasi",
                    onFilter: _ctx.fetchDestinationCity
                  }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
                ]),
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.typeListData,
                    modelValue: _ctx.typeExclude,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.typeExclude = $event)),
                    modalTitle: "Tipe Pengiriman",
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Ketik atau pilih tipe pengiriman"
                  }, null, 8, ["options", "modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.productListData,
                    modelValue: _ctx.productExclude,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.productExclude = $event)),
                    modalTitle: "Produk Pengiriman",
                    keyName: "name",
                    keyValue: "name",
                    isLoading: _ctx.isLoadingProduct,
                    placeholder: "Ketik atau pilih produk pengiriman",
                    onFilter: _ctx.fetchProduct
                  }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
                ]),
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.commodityListData,
                    modelValue: _ctx.commodityExclude,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.commodityExclude = $event)),
                    modalTitle: "Komoditas Pengiriman",
                    keyName: "commodity_name",
                    keyValue: "commodity_id",
                    isLoading: _ctx.isLoadingCommodity,
                    placeholder: "Ketik atau pilih komoditas pengiriman",
                    onFilter: _ctx.fetchCommodity
                  }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
                ]),
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, [
                    _createVNode(_component_InputAdornment, {
                      weight: _ctx.form.maxWeight,
                      "onUpdate:weight": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.maxWeight = $event)),
                      onChange: _ctx.onChangeWeight,
                      adornment: "Kg",
                      placeholder: "Berat maksimal"
                    }, null, 8, ["weight", "onChange"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_DatePickerV2, {
                    modelValue: _ctx.periodeStart,
                    modelValueTime: _ctx.periodeStartTime,
                    onSelected: _ctx.inputDateStart,
                    onSelectedTime: _ctx.inputDateStartTime,
                    minDate: _ctx.minDatePeriodeStart,
                    showTimePicker: "",
                    class: "my-2"
                  }, null, 8, ["modelValue", "modelValueTime", "onSelected", "onSelectedTime", "minDate"]),
                  _withDirectives(_createVNode("span", _hoisted_31, "Waktu mulai tidak boleh kurang atau sama dengan waktu saat ini", 512), [
                    [_vShow, _ctx.invalidStartTime]
                  ]),
                  _withDirectives(_createVNode("span", _hoisted_32, "Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir", 512), [
                    [_vShow, _ctx.invalidStartDate]
                  ])
                ]),
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_DatePickerV2, {
                    modelValue: _ctx.periodeEnd,
                    modelValueTime: _ctx.periodeEndTime,
                    onSelected: _ctx.inputDateEnd,
                    onSelectedTime: _ctx.inputDateEndTime,
                    minDate: _ctx.minDatePeriodeEnd,
                    showTimePicker: "",
                    class: "my-2"
                  }, null, 8, ["modelValue", "modelValueTime", "onSelected", "onSelectedTime", "minDate"]),
                  _withDirectives(_createVNode("span", _hoisted_35, "Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai", 512), [
                    [_vShow, _ctx.invalidEndDate]
                  ])
                ])
              ])
            ])
          ])
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Buat Rute Embargo Selesai",
      message: ` Rute embargo “${_ctx.form.name}” berhasil dibuat`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onCreate,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Pembuatan Rute Embargo",
      message: `Anda yakin akan menyimpan rute embargo “${_ctx.form.name}”`,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}